import { render, staticRenderFns } from "./putLinkIndex.vue?vue&type=template&id=6e8c50b0"
import script from "./putLinkIndex.vue?vue&type=script&lang=js"
export * from "./putLinkIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports